__turbopack_context__.v({
  "container": "LocationInfo-module__6pIxsa__container",
  "container__adress": "LocationInfo-module__6pIxsa__container__adress",
  "container__pin": "LocationInfo-module__6pIxsa__container__pin",
});
